import { useMemo } from 'react';

import { checkFinanceType, sortSplitKeys } from './helpers';

import { APRType, useFinanceFormContext } from '../../context';

export interface SplitKey {
  apr: string;
  financeType: APRType;
}

export interface APRsHook {
  splitKeys: SplitKey[] | undefined;
}

export default function useAPRs(): APRsHook {
  const { allRates } = useFinanceFormContext();

  const aprs = useMemo(() => {
    if (!allRates) return undefined;
    const keys = Object.keys(allRates);
    if (keys.length === 0) return undefined;
    return keys;
  }, [allRates]);

  const splitKeys = useMemo(
    () =>
      aprs?.reduce((final: SplitKey[], aprKey) => {
        const [apr, financeTypeString] = aprKey.split('-');
        const financeType = checkFinanceType(financeTypeString);
        if (!financeType) return final;
        return [
          ...final,
          {
            apr,
            financeType,
          },
        ];
      }, []),
    [aprs],
  );

  return {
    splitKeys: splitKeys ? sortSplitKeys(splitKeys) : undefined,
  };
}
